export const currencyNoSymbol = value =>
    new Intl.NumberFormat("th-TH", { style: "decimal", minimumFractionDigits: "2", maximumFractionDigits: "2" }).format(
        value,
    );
export const currencyTHB = value =>
    new Intl.NumberFormat("th-TH", { style: "currency", currency: "THB" }).format(value).replace("฿", "");
export const currencyUSD = value =>
    new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(value);
